import { FC } from 'react';
import { Badge } from '@new/common/ui/Badge/Badge';
import { useCourseHearingsContext } from '../../context/CourseHearingsContext';
import { HEARING_STATUS_OPTIONS } from '../../constants/courseHearings.constants';

export const HearingFilters: FC = () => {
  const { statusFilter, setStatusFilter } = useCourseHearingsContext();

  return (
    <div className="flex items-center gap-2">
      {HEARING_STATUS_OPTIONS.map(({ label, value }) => (
        <button key={value} onClick={() => setStatusFilter(value)} className="cursor-pointer">
          <Badge
            variant={statusFilter === value ? 'orange-solid' : 'white'}
            className="px-3 py-1.5 text-sm"
          >
            {label}
          </Badge>
        </button>
      ))}
    </div>
  );
};
